import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  hover?: boolean;
  glow?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e?: React.MouseEvent) => void;
}

const StyledCard = styled.div<CardProps>`
  background: white;
  border-radius: ${theme.borderRadius['2xl']};
  box-shadow: ${theme.shadows.base};
  transition: all 0.3s ease;

  ${props => {
    switch (props.padding) {
      case 'sm':
        return `padding: 1rem;`;
      case 'lg':
        return `padding: 2rem;`;
      default:
        return `padding: 1.5rem;`;
    }
  }}

  ${props => props.hover && `
    cursor: pointer;
    &:hover {
      transform: translateY(-4px);
      box-shadow: ${theme.shadows.lg};
    }
  `}

  ${props => props.glow && `
    border: 2px solid ${theme.colors.border.light};
    &:hover {
      border-color: ${theme.colors.primary[400]};
      box-shadow: ${theme.shadows.glow};
    }
  `}
`;

export const Card: React.FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

